<template>
  <div class="controller-process">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item class="mb-5" label="Tên" prop="name">
          <a-input v-model="form.name" placeholder="Tên" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Mô tả" prop="description">
          <div class="markdown-editor">
            <TinymceEditor
              api-key="j2mdtay9wwesglf7dchbaj5oicwn19zjvs7oxu4ju9dky54t"
              :init="{
                height: 500,
                menubar: false,
              }"
              v-model="form.description"
            />
          </div>
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Thứ tự" prop="arrangement">
          <a-input v-model="form.arrangement" placeholder="Thứ tự" />
        </a-form-model-item>
        <a-form-model-item class="mb-30" label="Ảnh" :colon="false">
          <input
            type="file"
            accept="image/png, image/svg, image/jpeg, image/gif, image/jpg"
            @change="onAvatarChange"
          />
        </a-form-model-item>
        <img
          v-show="avatarUrl"
          id="preview-avatar"
          :src="avatarUrl"
          class="preview-avatar"
        />
        <a-form-model-item>
          <a-row type="flex" justify="end">
            <a-button
              type="primary"
              :loading="callingAPI"
              @click="handleSubmit"
            >
              {{ $route.params.id ? "Cập nhật" : "Thêm mới" }}
            </a-button>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import ENDPOINT from '@/config/endpoint'
import TinymceEditor from '@tinymce/tinymce-vue'
import { createProcess, updateProcess, fetchProcessById } from '@/services/landing-page/home/process'
  export default {
    name: 'ControllerProcess',
    components: {
      TinymceEditor
    },
    data() {
      return {
        callingAPI: false,

        form: {
          name: '',
          description: '',
          arrangement: '',
          image: null,
          active: 1,
        },
        rules: {
          title: [
            { required: true, message: 'Giá trị không được để trống.', trigger: ['blur', 'change'] },
          ],
          description: [
            { required: true, message: 'Giá trị không được để trống.', trigger: ['blur', 'change'] },
          ],
          keyword: [
            { required: true, message: 'Giá trị không được để trống.', trigger: ['blur', 'change']  }
          ]
        },

        avatarUrl: "",
      }
    },
    async beforeMount() {
      if (this.$route.params.id) {
        await this.loadData()
      }
    },
    methods: {
      async loadData() {
        try {
          const response = await fetchProcessById(this.$route.params.id)
          this.form.name = response.data.name
          this.form.description = response.data.description
          this.form.arrangement = response.data.arrangement
          this.form.active = response.data.active

          this.avatarUrl = `${ENDPOINT.BACKEND_URL}/${response.data.image}`
        } catch (error) {
          
        }
      },
       onAvatarChange(e) {
        if (e.target.files.length) {
          const file = e.target.files[0];
          this.form.image = file;
          this.avatarUrl = URL.createObjectURL(file);
        }
      },
      handleSubmit(e) {
        e.preventDefault();
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            try {
              this.callingAPI = true
              if (!this.avatarUrl) {
                this.$message.error('Vui lòng upload ảnh đại diện!');
                this.callingAPI = false
                return;
              }

              const formData = new FormData()
              formData.append('name', this.form.name)
              formData.append('description', this.form.description)
              formData.append('arrangement', this.form.arrangement)
              formData.append('active', this.form.active)

              if (this.form.image) {
                formData.append('image', this.form.image)
              }

              if (this.$route.params.id) {
                formData.append('_method', 'PUT')
              }

              let response = null;
              if (this.$route.params.id) {
                 response = await updateProcess(this.$route.params.id, formData)
              } else {
                 response = await createProcess(formData)
              }
              if (response.status == 1) {
                const message = this.$route.params.id
                  ? "Cập nhật thành công."
                  : "Thêm mới thành công.";
                this.$notification.success({
                  message: "Thành công",
                  description: message,
                });
                this.$router.push({ name: "HomeProcess" });
              } else {
                this.$notification.error({
                  message: "Thất bại",
                  description: response.errors[0],
                });
              }
            } catch (error) {
              this.callingAPI = false
              console.log(error);
            }
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
#preview-avatar {
  max-width: 100%;
  object-fit: contain;
  display: block;
}
</style>